// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { PageLayout } from "#/features/global-ui/page-layout"
import { Title } from "#/services/page-title/Title"
import { Paths } from "#/utils/Paths"
import { BookingFlow } from "@internal/telemedicine"
import { useFlags } from "launchdarkly-react-client-sdk"
import React from "react"
import { Redirect, useHistory } from "react-router-dom"

export function TelemedicineBookingPage() {
  const { telemedicineBookingFlow } = useFlags()
  const history = useHistory()

  if (!telemedicineBookingFlow) {
    return <Redirect to={Paths.HOME} />
  }

  return (
    <PageLayout variant="default">
      <Title title="Telemedicine Booking" />
      <BookingFlow
        // TODO(OPS-9280): pass the program the member selected in the provider finder;
        // hardcoded until that plumbing exists.
        program="fertility"
        onExit={() => history.push(Paths.HOME)}
        onReturnToProviderResults={() => history.push(Paths.PROVIDER_FINDER)}
      />
    </PageLayout>
  )
}
